import {TPropsWithClassName} from 'core/types';
import React, {memo, PropsWithChildren, useEffect, useState} from 'react';
import parse from 'html-react-parser';

import style from './style.module.scss';

interface IProps {
    text: string;
    onChange?: (isExpanded: boolean) => void;
    collapsedButtonText?: string;
}

const MAX_TEXT_LENGTH_DEFAULT = 125;

export const CollapseBannerDescription = memo<TPropsWithClassName<PropsWithChildren<IProps>>>(({text, onChange}) => {
    const trimmedText = text.trim();

    const [contentText, setContentText] = useState(trimmedText.slice(0, MAX_TEXT_LENGTH_DEFAULT));
    const [clamped, setClamped] = useState(true);

    useEffect(() => {
        if (clamped) {
            setContentText(
                trimmedText.substring(0, MAX_TEXT_LENGTH_DEFAULT - 6) +
                    `<span class="collapse-text-button">...ещё</span>`,
            );
        } else {
            setContentText(trimmedText);
        }
    }, [clamped, trimmedText]);

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        const isExpanded = !clamped;
        setClamped(isExpanded);
        onChange?.(isExpanded);
    };

    const handleTextClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        handleClick(e);
    };

    return (
        <>
            <span onClick={handleTextClick} title={text} className={style.text}>
                {parse(contentText, {
                    replace: (domNode) => {
                        if (
                            domNode &&
                            'object' === typeof domNode &&
                            'type' in domNode &&
                            'tag' === domNode.type &&
                            'name' in domNode &&
                            'span' === domNode.name &&
                            'attribs' in domNode &&
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            'collapse-text-button' === (domNode as any).attribs?.class
                        ) {
                            return (
                                <span className={style.collapseTextButton} onClick={handleClick}>
                                    ...ещё
                                </span>
                            );
                        }
                        return undefined;
                    },
                })}
            </span>
        </>
    );
});
